import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import formationsStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formations'
const customImplement: CustomStoreImplementationOptions = formationsStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('bibliotheque-de-formations.title', 'Bibliothèque de formations | Matchers'),
        $description: $translate('bibliotheque-de-formations.description', 'Matchers vous met à disposition une bibliothèque de formations adaptables selon les besoins de votre entreprise !'),
        $publishedTime: new Date('2023-02-13T07:42:17.638Z'),
        $modifiedTime: new Date('2023-08-08T07:12:09.004Z'),
        // Constants,
        $constants: {},
        // Data,
        $info: { bibliothequeDeFormations: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async acquisitionDigitaleClick () {
        await navigateTo({ hash: '#marketing--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async referencementClick () {
        await navigateTo({ hash: '#container-1--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async eCommerceClick () {
        await navigateTo({ hash: '#container-12--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async communicationDigitaleClick () {
        await navigateTo({ hash: '#communication--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async financementClick () {
        await navigateTo({ hash: '#container-formations--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async managementClick () {
        await navigateTo({ hash: '#container-formations--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async gestionDeProjetsClick () {
        await navigateTo({ hash: '#container-formations--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async ressourcesHumainesClick () {
        await navigateTo({ hash: '#container-formations--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async seoClick () {
        await navigateTo({ hash: '#container-1--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async leveeDeFondsClick () {
        await navigateTo({ hash: '#container-formations--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async venteClick () {
        await navigateTo({ hash: '#marketing--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async uiUxDesignClick () {
        await navigateTo({ hash: '#communication--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async logistiqueClick () {
        await navigateTo({ query: {} }, true)
      },
      /* @ts-ignore: to allow override in your custom file */
      async relationClientClick () {
        await navigateTo({ hash: '#container-12--p40' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async consulterClick () {
        await navigateTo({ name: 'Formations-Seo' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async container2Click () {
        await navigateTo({ name: 'Formations-Seo' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button1Click () {
        await navigateTo({ name: 'Formations-Sea' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async seaClick () {
        await navigateTo({ name: 'Formations-Sea' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button2Click () {
        await navigateTo({ name: 'Formations-marketing-digital' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async marketingDigitalClick () {
        await navigateTo({ name: 'Formations-marketing-digital' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button3Click () {
        await navigateTo({ name: 'Formations-growth-hacking' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async growthHackingClick () {
        await navigateTo({ name: 'Formations-growth-hacking' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button4Click () {
        await navigateTo({ name: 'Formations-business-developer' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async salesClick () {
        await navigateTo({ name: 'Formations-business-developer' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button6Click () {
        await navigateTo({ name: 'Formations-communication-digitale' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button7Click () {
        await navigateTo({ name: 'Formations-reseaux-sociaux' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button8Click () {
        await navigateTo({ name: 'Formations-relations-presse' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async relationPresseClick () {
        await navigateTo({ name: 'Formations-relations-presse' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button9Click () {
        await navigateTo({ name: 'Formations-ui-ux-design' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async prendreRendezVousClick () {
        await navigateTo({ name: 'Contact' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button10Click () {
        await navigateTo({ name: 'Formations-levee-de-fonds' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button11Click () {
        await navigateTo({ name: 'Formations-ressources-humaines' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button12Click () {
        await navigateTo({ name: 'Formations-Management' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async button13Click () {
        await navigateTo({ name: 'Formations-gestion-de-projets' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsFactory(storeId)()
}

export const formationsRaw = formationsFactory()
export const formations = () => formationsRaw() as MergeCustomStore<typeof formationsStoreCustom.instance>
